import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'PriceEstimation' })((theme) => ({
    title: {
        marginBottom: 24
    },
    subtitle: {
        margin: 0,
        padding: 0,
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '27px',
        letterSpacing: '-0.54px',
        color: '#8E8E8E'
    },
    container: {
        marginTop: 64,
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 24,
        padding: '16px 40px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 40
        }
    },
    header: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '1.44px',
        textTransform: 'uppercase',
        color: '#8E8E8E'
    },
    borderless: {
        borderBottom: 0
    }
}));
